<template>
  <b-card-text>
    <b-form-row>
      <b-col>
        <b-form-group label="Datum">
          <b-input 
            :value="moment(offerte.datum).format('L')" 
            readonly
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Bedrag">
          <b-input 
            :value="offerte.bedrag" 
            readonly 
            type="number"
          />
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-group label="Activiteiten">
      <b-input 
        :value="offerte.activiteiten.join(', ')" 
        readonly 
        stacked
      />
    </b-form-group>
    <b-form-row>
      <b-col>
        <b-form-group label="Relatie">
          <b-input
            :value="offerte.relatie ? offerte.relatie.naam : '-geen geselecteerd-'"
            readonly
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Accountmanager">
          <b-input
            :value="offerte.toegewezen_aan ? offerte.toegewezen_aan.Naam : '-geen geselecteerd-'"
            readonly
          />
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-group label="Naam">
      <b-input 
        v-model="offerte.naam" 
        readonly
      />
    </b-form-group>
    <b-form-group label="Adres">
      <b-textarea 
        v-model="offerte.adres" 
        readonly
      />
    </b-form-group>
    <b-form-group label="Document">
      <b-button-toolbar v-if="offerte.bestand != null">
        <b-link 
          :href="offerte.bestand.secure_url" 
          target="_blank"
        >
          <font-awesome-icon icon="download" /> Download bestand
        </b-link>
      </b-button-toolbar>
    </b-form-group>
    <b-form-group label="Notitie">
      <b-textarea 
        v-model="offerte.omschrijving" 
        readonly
      />
    </b-form-group>
    <b-button 
      block 
      variant="success" 
      @click="() => $emit('opdracht', offerte)"
    >
      <font-awesome-icon icon="thumbs-up" /> Opdracht
    </b-button>
    <b-button 
      block 
      variant="danger" 
      @click="() => $emit('afgewezen', offerte)"
    >
      <font-awesome-icon icon="thumbs-down" /> Geen opdracht
    </b-button>
    <b-button 
      block 
      @click="() => $emit('edit', offerte)"
    >
      <font-awesome-icon icon="edit" /> Aanpassen offerte
    </b-button>
  </b-card-text>
</template>
<script>
import { verkoopMixin } from "@/mixins/verkoopMixin";
export default {
  name: "Openstaand",
  mixins: [verkoopMixin],
  props: {
    offerte: {
      type: Object,
      default: null,
    },
  },
  computed: {
    offertePath: function () {
      if (this.offerte != null) return `/offertes/offerte/${this.offerte.id}`;
    },
  },
  methods: {
    onDelete() {
      console.log("verwijderen... {0}",this.offertePath);
      var vm = this;
      this.deleteTraject(this.offertePath, { offerte: this.offerte }).then(
        function (response) {
          console.log(response.data);
          vm.emitDelete(vm.offerte);
        }
      );
    },
  },
};
</script>